import { render, staticRenderFns } from "./Xiaomi12tImage1.vue?vue&type=template&id=c1cef0f2&scoped=true&"
import script from "./Xiaomi12tImage1.vue?vue&type=script&lang=js&"
export * from "./Xiaomi12tImage1.vue?vue&type=script&lang=js&"
import style0 from "./Xiaomi12tImage1.vue?vue&type=style&index=0&id=c1cef0f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cef0f2",
  null
  
)

export default component.exports